export default __webpack_public_path__ + "static/media/Pfeilrechts.bafb92c9.svg";